var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFragViz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 32,
    viewBox: "0 0 160 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#6369D1",
    strokeWidth: 2,
    d: "M0 65L0 0 160 0 160 65"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 62,
    r: 22,
    stroke: "#6369D1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 45,
    r: 22,
    stroke: "#6369D1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 25,
    r: 12,
    stroke: "#6369D1",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFragViz);
export default __webpack_public_path__ + "static/media/frag_viz.4e6d7d6f08ba9f4ba3b270f22bbda6f0.svg";
export { ForwardRef as ReactComponent };